import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle-google-drive-logo",
  "use": "circle-google-drive-logo-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"circle-google-drive-logo\"><rect width=\"32\" height=\"32\" rx=\"16\" /><path d=\"M25.537 18.316L19.148 7.2h-6.296l6.389 11.116h6.296zm-11.667.926L10.722 24.8h12.13L26 19.242H13.87zM12.02 8.59L6 19.242 9.148 24.8l6.111-10.653-3.24-5.558z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol